$(function() {
    
    //
    // Set search roadblock Y location
    //
    
    function setRoadBlockYLoc() {
        $('.results-list').each(function() {
            var $results = $(this),
                firstResult = $results.find('> .mb-40px:first');
                                
            $('#roadBlockHelperStyles').remove();
            
            var roadBlockHelperStyles =
                '<style id="roadBlockHelperStyles">' +
                    '.roadblock-overlay__content {' +
                        'top: ' + (firstResult.position().top + firstResult.outerHeight()) + 'px;' +
                    '}' +
                '</style>';
            
            $(roadBlockHelperStyles).appendTo('head');
        });
    }
    
    if ($('.results-list > .mb-40px').length) {
        setRoadBlockYLoc();
        
        $(window).on('widthResizeEnd', function () {
            setRoadBlockYLoc();
        });
    }
    
    
    //
    // Set search roadblock overlay Y location
    //
    
    function setRoadBlockOverlayYLoc() {
        $('.results-list').each(function() {
            var calculateFromThis = ($('.results-list > .mb-40px').length) ? $('.results-list > .mb-40px').position().top : $(this).position().top / 2;
            
            $('#roadBlockOverlayHelperStyles').remove();
            
            var roadBlockOverlayHelperStyles =
                '<style id="roadBlockOverlayHelperStyles">' +
                    '.roadblock-overlay:after {' +
                        'top: ' + calculateFromThis + 'px;' +
                    '}' +
                '</style>';
            
            $(roadBlockOverlayHelperStyles).appendTo('head');
        });
    }
    
    setRoadBlockOverlayYLoc();
    
    $(window).on('widthResizeEnd', function () {
        setRoadBlockOverlayYLoc();
    });
    
    
    //
    // Apply min-height on roadblocked search column.
    //
    
    function applyMinHeight(el, elRelativeParent) {
        var $this = $(el),
            relativeParent = $this.closest(elRelativeParent),
            minHeight = Math.ceil(($this.offset().top - relativeParent.offset().top) + $this.outerHeight());
            
        relativeParent.css('min-height', '');
        relativeParent.css('min-height', minHeight + 'px');
    }
    
    if ($('.roadblock-overlay').length) {
        applyMinHeight('.roadblock-overlay__content', '.position-relative');
        
        $(window).on('widthResizeEnd', function () {
            applyMinHeight('.roadblock-overlay__content', '.position-relative');
        });    
    }
});